var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPendingicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_2422",
    "data-name": "Group 2422",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_9929",
    "data-name": "Path 9929",
    d: "M0,0H24V24H0Z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_9930",
    "data-name": "Path 9930",
    d: "M12,21.75A9.75,9.75,0,1,1,21.75,12,9.686,9.686,0,0,1,12,21.75ZM3.75,12A8.25,8.25,0,1,0,12,3.75,8.2,8.2,0,0,0,3.75,12Z",
    fill: "#f9a648"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_9931",
    "data-name": "Path 9931",
    d: "M15.5,12.75H12a.75.75,0,0,1,0-1.5h3.5a.75.75,0,0,1,0,1.5Z",
    fill: "#f9a648"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_9932",
    "data-name": "Path 9932",
    d: "M12,12.75a.75.75,0,0,1-.75-.75V7a.75.75,0,0,1,1.5,0v5A.75.75,0,0,1,12,12.75Z",
    fill: "#f9a648"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPendingicon);
export default __webpack_public_path__ + "static/media/pending icon.58f091cfb7c1016fc5108bc25888f94a.svg";
export { ForwardRef as ReactComponent };